<script setup>
const props = defineProps({
  eligibility: {
    type: Object,
  },
  event: {
    type: Object,
  },
})

const { t } = useI18n()
const type = computed(() => props.event?.type === 'appointment' ? t('appointment') : t('class'))

const showDailyLimit = ref(props.eligibility?.global_restrictions?.some(restriction => restriction.code === 'maximum_daily_registrations'))
const showWeeklyLimit = ref(props.eligibility?.global_restrictions?.some(restriction => restriction.code === 'maximum_weekly_registrations'))
</script>

<template>
  <!-- maximum_daily_registrations -->
  <div class="flex flex-col items-center flex-gap-y-2 whitespace-pre-wrap">
    <DSAlert
      v-if="showDailyLimit"
      type="danger"
      no-close
      class="w-100%"
    >
      {{ t('You cannot join this {type} because you are attending the maximum number of classes/appointments for this day', { type }) }}.
    </DSAlert>
    <!-- maximum_weekly_registrations -->
    <DSAlert
      v-if="showWeeklyLimit"
      type="danger"
      no-close
      class="w-100%"
    >
      {{ t('You cannot join this {type} because you are attending the maximum number of classes/appointments for this week', { type }) }}.
    </DSAlert>
  </div>
</template>

<i18n>
{
  "en-us": {
    "class": "class",
    "appointment": "appointment",
    "You cannot join this {type} because you are attending the maximum number of classes/appointments for this day": "You cannot join this {type} because you are attending the maximum number of classes/appointments for this day",
    "You cannot join this {type} because you are attending the maximum number of classes/appointments for this week": "You cannot join this {type} because you are attending the maximum number of classes/appointments for this week"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "You cannot join this {type} because you are attending the maximum number of classes/appointments for this day": "Du kannst an diesem Kurs leider nicht teilnehmen, da du die maximale Anzahl von Buchungen für einen Tag erreicht hast.",
  "You cannot join this {type} because you are attending the maximum number of classes/appointments for this week": "Du kannst an diesem Kurs leider nicht teilnehmen, da du die maximale Anzahl von Buchungen für diese Woche erreicht hast.",
  "appointment": "Termin",
  "class": "Klasse"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "You cannot join this {type} because you are attending the maximum number of classes/appointments for this day": "Vous ne pouvez pas rejoindre ce cours, car vous assistez déjà au nombre maximum de cour pour ce jour",
  "You cannot join this {type} because you are attending the maximum number of classes/appointments for this week": "Vous ne pouvez pas rejoindre ce cours, car vous assistez déjà au nombre maximum de cour pour cette semaine",
  "appointment": "rendez-vous",
  "class": "classe"
}
</i18n>

<i18n locale="es" lang="json">
{
  "You cannot join this {type} because you are attending the maximum number of classes/appointments for this day": "No puede entrar en esta clase porque ya asiste al número máximo de clases por hoy",
  "You cannot join this {type} because you are attending the maximum number of classes/appointments for this week": "No puede unirse a esta clase porque ya asiste al número máximo de clases por esta semana",
  "appointment": "cita",
  "class": "clase"
}
</i18n>
